<template>
  <div class="dashboard">
    <!-- 顶部导航 -->
    <!-- <header class="topbar">
      <button class="menu-btn" @click="menuOpen = !menuOpen">☰</button>
      <div class="brand">
        <img src="/src/assets/logo1.png" alt="logo" />
      </div>
      <div class="user-dropdown" ></div>
    </header> -->

    <!-- 移动端菜单（左侧抽屉） -->
    <transition name="drawer-slide">
      <div v-if="menuOpen" class="mobile-menu" @click.self="menuOpen = false">
        <div class="menu-panel" @click.stop>
          <!-- 顶部头像与名称 -->
          <div class="user-info" @click="openProfile">
            <div class="user-avatar">
              <img :src="userInfo.avatar_pull" alt="avatar" />
            </div>
            <div class="user-name">
              <span>{{ userInfo.name || 'XXXX' }}</span>
            </div>
          </div>

          <!-- 菜单列表 -->
          <div class="menu-list">
            <div
              class="menu-section"
              v-for="(item, index) in menus"
              :key="item.id"
            >
              <div class="menu-section-header" :class="{ active: activeMenu === index && !activeChildId }">
                <div class="menu-section-header-content">
                  <i class="iconfont-sys" v-html="item.icon" style="margin-right: 10px;"></i>
                  <span @click="onNav(item.id, index, true)">{{ item.name }}</span>
                </div>
                <i
                  v-if="item.children && item.children.length > 0"
                  class="arrow-icon"
                  :class="{ expanded: expandedMenus.has(item.id) }"
                  @click.stop="toggleMobileSection(item, index)"
                >
                  ▼
                </i>
              </div>
              <div
                class="menu-section-body"
                v-if="expandedMenus.has(item.id)"
              >
                <div
                  class="menu-link"
                  :class="{ active: activeChildId === children.id }"
                  v-for="children in item.children || []"
                  :key="children.id"
                  @click="onNav(children.id, index, true)"
                >
                  {{ children.name }}
                </div>
              </div>
            </div>
          </div>

          <!-- 底部退出 -->
          <div class="logout-row" @click="confirmLogout">
            <img src="/src/assets/logout.png" alt="logout" />
            <span class="logout-text">退出</span>
          </div>
        </div>
      </div>
    </transition>
    <!-- 顶部banner -->
    <button class="menu-btn" @click="menuOpen = !menuOpen">☰</button>
    <div v-if="bannerList.length > 0" class="banner">
      <div class="banner-carousel" v-if="bannerList.length > 1">
        <div 
          class="banner-slide" 
          v-for="(img, index) in bannerList" 
          :key="index"
          :class="{ active: currentBannerIndex === index }"
        >
          <img :src="img" alt="banner" />
        </div>
        <!-- 轮播指示器 -->
        <div class="banner-indicators">
          <span 
            v-for="(img, index) in bannerList" 
            :key="index"
            class="indicator"
            :class="{ active: currentBannerIndex === index }"
            @click="currentBannerIndex = index"
          ></span>
        </div>
      </div>
      <div v-else class="banner-single">
        <img :src="bannerList[0]" alt="banner" />
      </div>
    </div>
    <!-- 图片预览 -->
    <div v-if="previewVisible" class="preview-overlay" @click.self="closeImagePreview">
      <div class="preview-wrapper">
        <button class="preview-close" @click="closeImagePreview">×</button>
        <div class="preview-image-container">
          <button v-if="previewImages.length > 1" class="preview-nav left" @click.stop="prevPreview">‹</button>
          <img 
            :src="previewImages[previewIndex]" 
            alt="preview" 
            @touchstart="startPreviewLongPress" 
            @touchend="clearPreviewLongPress"
            @touchcancel="clearPreviewLongPress"
            @mousedown.prevent="startPreviewLongPress"
            @mouseup="clearPreviewLongPress"
            @mouseleave="clearPreviewLongPress"
          />
          <button v-if="previewImages.length > 1" class="preview-nav right" @click.stop="nextPreview">›</button>
        </div>
        <div class="preview-indicators" v-if="previewImages.length > 1">
          <span 
            v-for="(img, idx) in previewImages" 
            :key="idx"
            class="indicator"
            :class="{ active: previewIndex === idx }"
            @click="previewIndex = idx"
          ></span>
        </div>
        <div class="preview-tip">长按图片可下载</div>
        <!-- <button class="preview-download" @click.stop="downloadImage(previewImages[previewIndex])">下载当前图片</button> -->
      </div>
    </div>

    <!-- 主体内容 -->
    <main class="mobile-content">
      
      <template v-for="m in menus" :key="m.id">
        <!-- 父级 section -->
        <section :id="`sec-${m.id}`" class="section" v-if="m.cards && m.cards.length > 0">
          <h3>{{ m.name }}</h3>
          <div class="title-block"></div>
          <div class="card-grid">
            <div class="card" v-for="(item, index) in m.cards" :key="index" @click="onCardClick(item)">
              <div class="icon">
                <img src="/src/assets/card-icon.png" alt="icon" />
              </div>
              <div class="info">
                <div class="title">{{ item.title }}</div>
                <div class="desc">{{ item.description }}</div>
              </div>
            </div>
          </div>
        </section>
        <!-- 子级 section -->
        <template v-for="children in m.processedChildren" :key="children.id">
          <section :id="`sec-${children.id}`" class="section" v-if="children.cards && children.cards.length > 0">
            <h3>{{ children.parentName }} / {{ children.name }}</h3>
            <div class="title-block"></div>
            <div class="card-grid">
              <div class="card" v-for="(item, index) in children.cards" :key="index" @click="onCardClick(item)">
                <div class="icon">
                  <img src="/src/assets/card-icon.png" alt="icon" />
                </div>
                <div class="info">
                  <div class="title">{{ item.title }}</div>
                  <div class="desc">{{ item.description }}</div>
                </div>
              </div>
            </div>
          </section>
        </template>
      </template>
    </main>

    <!-- 修改资料弹窗 -->
    <div v-if="showProfile" class="modal-overlay" @click.self="showProfile = false">
      <div class="modal profile-modal">
        <!-- 顶部用户信息 -->
        <div class="profile-header">
          <div class="profile-avatar">
            <img :src="userInfo.avatar_pull" alt="avatar" />
          </div>
          <div class="profile-meta">
            <div class="profile-name">{{ userInfo.name }}</div>
            <div class="profile-sub">联系电话：{{ userInfo.mobile || '-' }}</div>
            <div class="profile-sub">编号：{{ userInfo.sn || '-' }}</div>
          </div>
        </div>

        <!-- 基本设置 -->
        <div class="profile-section">
          <div class="section-title">
            <span class="dot"></span>
            <span>基本设置</span>
          </div>
          <div class="section-body">
            <div class="avatar-block">
              <div class="label">头像</div>
              <div class="avatar-edit">
                <img :src="userInfo.avatar_pull" alt="avatar" class="avatar-lg" />
                <input v-if="basicEditing" type="file" @change="uploadAvatar" />
              </div>
            </div>
            <div class="form-grid">
              <div class="form-field">
                <label>昵称</label>
                <input 
                  class="input" 
                  :disabled="!basicEditing" 
                  v-model="userInfo.nickname" 
                  placeholder="请输入昵称" 
                />
              </div>
              <div class="form-field">
                <label>联系方式</label>
                <input 
                  class="input" 
                  :disabled="!basicEditing" 
                  v-model="userInfo.mobile" 
                  placeholder="请输入联系方式" 
                />
              </div>
              <div class="form-field">
                <label>编号</label>
                <input 
                  class="input" 
                  disabled 
                  v-model="userInfo.sn" 
                  placeholder="请输入编号" 
                />
              </div>
            </div>
          </div>
          <div class="actions">
            <button class="edit-btn" @click="saveProfile">{{ basicEditing ? '保存' : '编辑' }}</button>
          </div>
        </div>

        <!-- 更改密码 -->
        <div class="profile-section">
          <div class="section-title">
            <span class="dot"></span>
            <span>更改密码</span>
          </div>
          <div class="section-body">
            <div class="form-grid">
              <div class="form-field">
                <label>当前密码</label>
                <input 
                  class="input" 
                  :type="pwdEditing ? 'password' : 'password'" 
                  :disabled="!pwdEditing" 
                  v-model="pwdForm.password" 
                  placeholder="请输入原始密码" 
                />
              </div>
              <div class="form-field">
                <label>新密码</label>
                <input 
                  class="input" 
                  :type="pwdEditing ? 'password' : 'password'" 
                  :disabled="!pwdEditing" 
                  v-model="pwdForm.password_new" 
                  placeholder="请输入新密码" 
                />
              </div>
              <div class="form-field">
                <label>确认新密码</label>
                <input 
                  class="input" 
                  :type="pwdEditing ? 'password' : 'password'" 
                  :disabled="!pwdEditing" 
                  v-model="pwdForm.confirm" 
                  placeholder="请输入确认密码" 
                />
              </div>
            </div>
          </div>
          <div class="actions">
            <button class="edit-btn" @click="onResetPassword">{{ pwdEditing ? '保存' : '编辑' }}</button>
          </div>
        </div>

        <div class="modal-actions">
          <button class="btn ghost" @click="showProfile = false">关闭</button>
        </div>
      </div>
    </div>

    <!-- 退出登录确认 -->
    <div v-if="showLogoutConfirm" class="modal-overlay" @click.self="showLogoutConfirm = false">
      <div class="modal confirm-modal">
        <h3>确认退出登录？</h3>
        <p style="color:#666;margin-top:6px;">退出后需要重新登录才能进入系统。</p>
        <div class="modal-actions">
          <button class="btn ghost" @click="showLogoutConfirm = false">取消</button>
          <button class="btn primary" @click="doLogout">确认退出</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import { getMenus, getUser, updateUserInfo, resetPassword, uploadImage, getConfig } from "../api";
import { ElMessage } from 'element-plus'
const menus = ref([]);
const profile = ref({ username: "", password: "" });
const showProfile = ref(false);
const menuOpen = ref(false);
const basicEditing = ref(false);
const pwdEditing = ref(false);
const pwdForm = ref({ password: "", password_new: "", confirm: "" });
const showUserMenu = ref(false);
const showLogoutConfirm = ref(false);
const userInfo = ref({});
const bannerList = ref([]);
const currentBannerIndex = ref(0);
const previewVisible = ref(false);
const previewImages = ref([]);
const previewIndex = ref(0);
let previewLongPressTimer = null;

onMounted(async () => {
  try {
    const {data: bannerData}= await getConfig({ code: 'm_banner' })
    // 处理banner数据：可能是空、单个图片或逗号分隔的多个图片
    if (bannerData && bannerData.value_pull) {
      const bannerStr = bannerData.value_pull.trim();
      if (bannerStr) {
        // 按逗号分隔，过滤空字符串
        bannerList.value = bannerStr.split(',').map(url => url.trim()).filter(url => url);
      }
    }
    
    // 如果有多个图片，启动自动轮播
    if (bannerList.value.length > 1) {
      startBannerCarousel();
    }
    const m = await getMenus();
    // const res = m.data;
    const res = m.data;
    // 处理数据结构，为父级和子级都准备 cards
    menus.value = res.map((section) => {
      // 处理父级的 nav_item
      const parentCards = (section.nav_item || []).map((c) =>
        typeof c === "string"
          ? { title: c, description: "" }
          : c
      );
      
      // 处理子级，为每个子级准备 cards 数据
      const processedChildren = (section.children || []).map((children) => {
        const childCards = (children.nav_item || []).map((c) =>
          typeof c === "string"
            ? { title: c, description: "" }
            : c
        );
        return {
          ...children,
          cards: childCards,
          parentName: section.name, // 保存父级名称，用于显示标题
        };
      });
      
      return {
        ...section,
        cards: parentCards,
        processedChildren: processedChildren, // 保存处理后的子级数据
      };
    });
    // 初始化展开当前激活的菜单项
    const activeItem = menus.value[activeMenu.value];
    if (activeItem && activeItem.children && activeItem.children.length > 0) {
      expandedMenus.value.add(activeItem.id);
    }
    const {data} = await getUser();
    userInfo.value = data.user;
  } catch (e) {
    console.error(e);
  }
});

// 轮播图自动播放
let bannerTimer = null;
function startBannerCarousel() {
  if (bannerList.value.length <= 1) return;
  
  bannerTimer = setInterval(() => {
    currentBannerIndex.value = (currentBannerIndex.value + 1) % bannerList.value.length;
  }, 3000); // 每3秒切换一次
}

// 组件卸载时清除定时器
onUnmounted(() => {
  if (bannerTimer) {
    clearInterval(bannerTimer);
  }
  clearPreviewLongPress();
});
// 下载文件
async function onCardClick(item){
  if (!item) return;
  const url_pull = item.url_pull;
  const type = item.type;
  if (!url_pull) return;
  if (type === 'link') {
    window.open(url_pull, '_blank');
    return;
  }
  if (type === 'image') {
    openImagePreview(url_pull);
    return;
  }

  if (type === 'file') {
    // window.open(url_pull, '_blank');
    // try {
    //   const link = document.createElement('a');
    //   link.href = url_pull; // 后端给的完整 OSS URL
    //   link.download = item.title  || 'download';
    //   link.style.display = 'none';
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);

    //   ElMessage.success('下载成功');
    // } catch (error) {
    //   console.error('下载失败:', error);
    //   ElMessage.error('下载失败');
    // }
    try {
      // 对所有文件类型都使用 fetch 下载，确保真正的下载
      // 微信、飞书内不允许 blob 下载，直接跳转下载
      if (/MicroMessenger|Feishu/.test(navigator.userAgent)) {
        window.location.href = url_pull
        return
      }
      const response = await fetch(url_pull, {
        method: 'GET',
        headers: {
          Accept: '*/*'
        }
      })
      
      if (!response.ok) {
        throw new Error(`下载失败: ${response.status} ${response.statusText}`)
      }
      const blob = await response.blob()
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = item.title || 'download'
      link.style.display = 'none'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
      
      // ElMessage.success('下载成功')
    } catch (error) {
      console.error('下载失败:', error)
      const errorMessage = error instanceof Error ? error.message : '未知错误'
      ElMessage.error(`下载失败: ${errorMessage}`)
    }
    return;
  }
}

const activeMenu = ref(0);
const activeChildId = ref(null); // 跟踪当前选中的子菜单ID
const expandedMenus = ref(new Set()); // 用于跟踪展开的菜单项
function onNav(id, index, closeMenu = false) {
  activeMenu.value = index;
  
  // 判断是父级还是子级菜单
  const currentMenu = menus.value[index];
  if (currentMenu.id === id) {
    // 点击的是父级菜单
    activeChildId.value = null;
  } else if (currentMenu.children && currentMenu.children.some(child => child.id === id)) {
    // 点击的是子级菜单
    activeChildId.value = id;
  }
  
  const el = document.getElementById(`sec-${id}`);
  if (el) {
    const offset = 64;
    const y = el.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top: y, behavior: "smooth" });
  }
  if (closeMenu) {
    menuOpen.value = false;
  }
}

function toggleMobileSection(item, index) {
  activeMenu.value = index;
  if (expandedMenus.value.has(item.id)) {
    expandedMenus.value.delete(item.id);
  } else {
    expandedMenus.value.clear();
    expandedMenus.value.add(item.id);
  }
}

async function uploadAvatar(e){
  const file = e.target.files[0];
  const formData = new FormData();
  formData.append('image', file);
  formData.append('scene', 'user');
  const { data } = await uploadImage(formData);
  if (data) {
    userInfo.value.avatar = data.href;
    userInfo.value.avatar_pull = data.url;
  }
}
async function saveProfile(){
  basicEditing.value = !basicEditing.value;
  if(basicEditing.value) return;
  try {
    const { data } = await updateUserInfo(userInfo.value);
  } catch (e) {
    console.error('保存用户信息失败', e);
  } finally {
    basicEditing.value = false;
  }
}
async function onResetPassword(){
  pwdEditing.value = !pwdEditing.value;
  if(pwdEditing.value) return;
  if(pwdForm.value.password_new !== pwdForm.value.confirm){
    alert('新密码和确认密码不一致');
    return;
  }
  try {
    const { message } = await resetPassword(pwdForm.value);
    alert(message);
  } catch (e) {
    alert(e?.response?.data?.message || '重置密码失败');
  }
}
function toggleUserMenu(){
  showUserMenu.value = !showUserMenu.value;
}
function normalizeImageList(urlStr = ''){
  return urlStr.split(',').map(url => url.trim()).filter(url => url);
}
function openImagePreview(urlStr){
  // const images = normalizeImageList(urlStr);
  const images = urlStr;
  if(!images.length) return;
  previewImages.value = images;
  previewIndex.value = 0;
  previewVisible.value = true;
}
function closeImagePreview(){
  previewVisible.value = false;
  previewImages.value = [];
  previewIndex.value = 0;
  clearPreviewLongPress();
}
function nextPreview(){
  if(previewImages.value.length <= 1) return;
  previewIndex.value = (previewIndex.value + 1) % previewImages.value.length;
}
function prevPreview(){
  if(previewImages.value.length <= 1) return;
  previewIndex.value = (previewIndex.value - 1 + previewImages.value.length) % previewImages.value.length;
}
function startPreviewLongPress(){
  clearPreviewLongPress();
  previewLongPressTimer = setTimeout(() => {
    downloadImage(previewImages.value[previewIndex.value]);
  }, 600);
}
function clearPreviewLongPress(){
  if(previewLongPressTimer){
    clearTimeout(previewLongPressTimer);
    previewLongPressTimer = null;
  }
}
async function downloadImage(url_pull){
  // try {
  //   const link = document.createElement('a');
  //   link.href = url_pull; // 后端给的完整 OSS URL
  //   link.download = '图片';
  //   link.style.display = 'none';
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  //   ElMessage.success('下载成功');
  // } catch (error) {
  //   console.error('下载失败:', error);
  //   // ElMessage.error('下载失败');
  // }
}
async function openProfile(){
  showUserMenu.value = false;
  try {
    const { data } = await getUser();
    if (data.user) {
      userInfo.value = data.user;
      profile.value.nickname = data.user.nickname || data.user.name || '';
      profile.value.phone = data.user.phone || '';
      profile.value.code = data.user.code || data.user.id || '';
    }
  } catch (e) {
    console.error('获取用户信息失败', e);
  } finally {
    showProfile.value = true;
  }
}
function confirmLogout(){
  showUserMenu.value = false;
  showLogoutConfirm.value = true;
}
function doLogout(){
  // 清空本地缓存并跳转登录
  localStorage.clear();
  window.location.href = '/login';
}

window.addEventListener('click', () => { showUserMenu.value = false; });
</script>

<style scoped>
.dashboard {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f2f5f9;
}

/* 顶部导航 */
.topbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 6px 16px rgba(15, 27, 43, 0.08);
  /* z-index: 120; */
}
.brand img {
  height: 22px;
}
.menu-btn {
  border: none;
  font-size: 22px;
  color: #fff;
  cursor: pointer;
  position: fixed;
  background: rgb(104 171 164 / 50%);
}
.user-dropdown{ position:relative; }
.user-dropdown img.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 2px solid rgba(20, 201, 201, 0.2);
}
.user-dropdown .dropdown-menu{
  position:absolute; right:0; top:46px; width:140px; background:#fff; border:1px solid #e5e7eb; border-radius:12px; box-shadow:0 16px 30px rgba(0,0,0,.08); z-index:150;
}
.user-dropdown .dropdown-menu .item{ padding:10px 12px; cursor:pointer; font-size:14px; color:#333; }
.user-dropdown .dropdown-menu .item:hover{ background:#f6fbfb; color:#009999; }
.user-dropdown .dropdown-menu .item.danger{ color:#e35d5d; }

/* 移动菜单 */
.mobile-menu {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  z-index: 110;
}
.menu-panel {
  width: 65%;
  max-width: 320px;
  background: #fff;
  padding: 18px 20px 24px;
  background: linear-gradient(180.04deg, #14C4C4 0.04%, #FFFFFF 18.62%);

  height: 100%;
}
.user-info{
  display:flex;
  align-items:center;
  padding:18px 4px 16px;
  gap:10px;
}
.user-avatar img{
  width:40px;
  height:40px;
  border-radius:50%;
  border:2px solid rgba(255,255,255,0.7);
}
.user-name span{
  font-size:14px;
  font-weight:600;
  color:#ffffff;
}
.menu-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  color: #666666;
  margin-bottom: 8px;
}
.close-btn {
  border: none;
  background: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
}
.menu-list {
  max-height: 80vh;
  overflow-y: auto;
}
.menu-section {
  /* border-bottom: 1px solid #eef1f4; */
  padding: 8px 0;
}
.menu-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 15px;
  font-weight: 600;
  color: #666666;
  padding: 8px 12px;
  border-radius: 8px;
  transition: all 0.2s;
}
.menu-section-header.active {
  background: rgba(20, 196, 196, 0.15);
  color: #14C4C4;
}
.menu-section-header.active .menu-section-header-content span {
  color: #14C4C4;
}
.menu-section-header.active .iconfont-sys {
  color: #14C4C4;
}
.menu-section-body {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.menu-link {
  padding: 10px 14px;
  border-radius: 8px;
  color: #666666;
  font-size: 14px;
  transition: all 0.2s;
  cursor: pointer;
}
.menu-link.active {
  background: rgba(20, 196, 196, 0.15);
  color: #14C4C4;
  font-weight: 600;
}

.logout-row{
  margin-top:auto;
  padding:14px 10px 8px;
  display:flex;
  align-items:center;
  gap:8px;
  color:#666;
  font-size:14px;
  position: fixed;
  bottom: 20px;
}
.logout-icon{
  font-size:14px;
}
.menu-link:active {
  background: #e0f4f4;
}
.arrow-icon {
  font-size: 12px;
  transition: transform 0.3s ease;
}
.arrow-icon.expanded {
  transform: rotate(180deg);
}

.drawer-slide-enter-active,
.drawer-slide-leave-active {
  transition: all 0.25s ease;
}
.drawer-slide-enter-from,
.drawer-slide-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}

/* 内容区 */
.mobile-content {
  padding: 0px 12px 24px;
  margin-top: 20px;
}
.section {
  /* background: #fff; */
  /* border-radius: 20px; */
  /* padding: 18px; */
  margin-bottom: 18px;
  /* box-shadow: 0 8px 20px rgba(15, 27, 43, 0.08); */
}
.section h3 {
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 12px;
  color: #0f1b2b;
}
.title-block {
  width: 40px;
  height: 8px;
  background: #14c9c9;
  margin-bottom: 16px;
  margin-top: -20px;
}

.card-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.card {
  background: #f7fbfb;
  border-radius: 16px;
  padding: 14px;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  box-shadow: inset 0 0 0 1px rgba(20, 201, 201, 0.1);
}
.card .icon img {
  width: 36px;
  height: 36px;
}
.card .info .title {
  font-size: 15px;
  font-weight: 600;
  color: #0f1b2b;
}
.card .info .desc {
  font-size: 12px;
  color: #5f6b7a;
  margin-top: 4px;
}

/* 弹窗 */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
  z-index: 200;
}
.modal {
  background: #fff;
  padding: 18px;
  width: 340px;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  max-height: calc(100vh - 40px);
  overflow-y: auto;
}
.profile-modal{
  width: 96vw;
  max-width: 520px;
  border-radius: 24px;
  padding: 20px;
}
.profile-header{
  display:flex;
  align-items:center;
  gap:16px;
  padding:16px;
  background:linear-gradient(135deg,#ecfafa,#ffffff);
  border-radius:16px;
  margin-bottom:18px;
}
.profile-avatar img{ width:56px; height:56px; border-radius:50%; }
.profile-meta{ display:flex; flex-direction:column; gap:4px; }
.profile-name{ font-size:16px; font-weight:700; color:#222; }
.profile-sub{ font-size:12px; color:#666; }

.profile-section{
  background:#fff;
  border:1px solid #eef2f2;
  border-radius:16px;
  padding:16px 14px 20px;
  margin:16px 0;
}
.section-title{ display:flex; align-items:center;margin-bottom:10px; }
.section-title .dot{ width:6px; height:16px; background:#14C9C9; border-radius:3px; display:inline-block; margin-right:8px; }
.section-title > span:first-child{ margin-right:8px; }
.edit-btn{ border:1px solid #14C9C9; color:#14C9C9; background:#ecfafa; border-radius:6px; padding:6px 12px; cursor:pointer; }
.section-body{ padding:4px 0; display:flex; flex-direction:column; gap:16px; }
.avatar-block{
  display:flex;
  align-items:center;
  gap:16px;
  padding:8px 0;
}
.avatar-block .label{
  width:60px;
  font-size:13px;
  color:#666;
}
.avatar-edit{ display:flex; align-items:center; gap:12px; flex:1; }
.avatar-lg{ width:64px; height:64px; border-radius:50%; border:2px solid #eef2f2; }
.form-grid{
  display:grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap:14px;
}
.form-field{
  display:flex;
  flex-direction:column;
  gap:6px;
}
.form-field label{
  font-size:13px;
  color:#666;
}
.input{
  width:100%;
  height:38px;
  border:1px solid #e5e7eb;
  border-radius:10px;
  padding:0 12px;
  background:#fafafa;
}

.modal-actions{ display:flex; justify-content:flex-end; gap:8px; margin-top:8px; }
.btn{ padding:8px 14px; border-radius:8px; border:1px solid transparent; cursor:pointer; }
.btn.ghost{ background:#fff; border-color:#e5e7eb; }
.btn.primary{ background:#14C9C9; color:#fff; }
.modal label {
  display: block;
  margin-top: 8px;
  color: #555;
}
.actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 12px;
}
.banner {
  width: 100%;
  margin-bottom: 16px;
  overflow: hidden;
}
.banner-single img {
  width: 100%;
  object-fit: cover;
  display: block;
}
.banner-carousel {
  position: relative;
  width: 100%;
  height: 180px;
  overflow: hidden;
}
.banner-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}
.banner-slide.active {
  opacity: 1;
  z-index: 1;
}
.banner-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.banner-indicators {
  position: absolute;
  bottom: 12px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;
  z-index: 2;
}
.banner-indicators .indicator {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: all 0.3s;
}
.banner-indicators .indicator.active {
  background: #fff;
  width: 20px;
  border-radius: 3px;
}

.preview-overlay{
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.72);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 250;
  padding: 20px;
  box-sizing: border-box;
}
.preview-wrapper{
  width: 100%;
  max-width: 420px;
  /* background: rgba(0,0,0,0.4); */
  border-radius: 20px;
  padding: 16px;
  color: #fff;
  position: relative;
  text-align: center;
}
.preview-close{
  position: absolute;
  top: 8px;
  right: 12px;
  background: none;
  border: none;
  font-size: 26px;
  color: #fff;
  cursor: pointer;
}
.preview-image-container{
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.preview-image-container img{
  max-width: 100%;
  max-height: 60vh;
  border-radius: 12px;
}
.preview-nav{
  background: none;
  border: none;
  color: #fff;
  font-size: 40px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
}
.preview-indicators{
  margin: 12px 0;
  display: flex;
  justify-content: center;
  gap: 8px;
}
.preview-indicators .indicator{
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(255,255,255,0.4);
}
.preview-indicators .indicator.active{
  background: #fff;
}
.preview-tip{
  font-size: 12px;
  color: rgba(255,255,255,0.8);
  margin-bottom: 8px;
}
.preview-download{
  width: 100%;
  padding: 10px;
  border-radius: 999px;
  border: none;
  background: linear-gradient(90deg,#00b7a7,#00cda3);
  color: #fff;
  font-size: 15px;
}

/* 移动端适配 */
.drawer-overlay { display: none; }

@media (max-width: 480px) {
  .topbar {
    height: 52px;
    padding: 0 14px;
  }
  .mobile-content {
    padding: 0px 14px 20px;
  }
  .menu-panel {
    padding: 16px;
  }
  .modal {
    width: 92%;
    max-height: calc(100vh - 32px);
  }
  .profile-modal{
    width: 94vw;
    padding: 16px;
  }
  /* .avatar-block{
    flex-direction: column;
    align-items: flex-start;
  } */
  .avatar-block .label{
    width: auto;
  }
  .form-grid{
    grid-template-columns: 1fr;
  }
}
</style>
